export default "ALTER TABLE `budgets` ADD `type` text DEFAULT 'expense' NOT NULL;\n";